
export const getURLQuery = (search:string,query:string)=>{
    return new URLSearchParams(search).get(query);
}